import api from './api';

const invitesService = {
  async getAll() {
    const response = await api.get('/invites');
    return response.data;
  },

  async create(dto) {
    const response = await api.post('/invites', dto);
    return response.data;
  },

  async cancel(id) {
    await api.delete(`/invites/${id}`);
    return null;
  },
};

export default invitesService;
